/* global lozad hUrl movieCategorySlug categorySlug */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass(
      'active'
    )
    $('body').toggleClass('lock')
  })

  $('img').each(function() {
    // キャッシュ強制更新
    //imgタグがある限り繰り返し実行
    var imgSrc = $(this).attr('src') //画像のソースURLを取得し、変数に格納
    $(this).attr('src', imgSrc + '?v=202104210700') //本来のソースURLをクエリパラメータ付きURLで置換
  })

  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  $('.js-slick-top-mv').slick({
    // スライダー
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: false,
    // 自動再生。trueで自動再生される。
    autoplay: true,
    // 自動再生で切り替えをする時間
    autoplaySpeed: 6000,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 600,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: false,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'js-slick-dot',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: true,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: false,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: true,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false
    // 表示中の画像を中央へ
    // centerMode: true,
    // 中央のpadding
    // centerPadding: '0'
  })

  $('.js-slick-top-reason').slick({
    // スライダー
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: true,
    // 自動再生。trueで自動再生される。
    autoplay: true,
    // 自動再生で切り替えをする時間
    autoplaySpeed: 3000,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 600,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: true,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'js-slick-dot',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: true,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: true,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: true,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false
    // 表示中の画像を中央へ
    // centerMode: true,
    // 中央のpadding
    // centerPadding: '0'
  })

  $('.js-slick-access').slick({
    // スライダー
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: true,
    // 自動再生。trueで自動再生される。
    autoplay: true,
    // 自動再生で切り替えをする時間
    autoplaySpeed: 6000,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 600,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: true,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'js-slick-dot',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: false,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: true,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: true,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false,
    // 表示中の画像を中央へ
    centerMode: true,
    // 中央のpadding
    centerPadding: '10.3%'
  })

  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  const footerFixed = $('.fotter-stay')
  let showFlag = false
  footerFixed.css('bottom', '-64px')
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      if (!showFlag) {
        showFlag = true
        footerFixed.stop().animate({ bottom: '0' }, 200)
      }
    } else {
      if (showFlag) {
        showFlag = false
        footerFixed.stop().animate({ bottom: '-64px' }, 200)
      }
    }
  })

  $('#js-movie-category-select').change(function() {
    var slug = $(this).val()
    if (slug === '0') {
      window.location.href = hUrl + 'movie/'
    } else if (slug) {
      window.location.href = hUrl + 'movie/movie-category/' + slug + '/'
    }
    return false
  })
  if (typeof movieCategorySlug !== 'undefined' && movieCategorySlug) {
    $('#js-movie-category-select').val(movieCategorySlug)
  }

  $('#js-category-select').change(function() {
    var slug = $(this).val()
    var type = $(this)
      .find('option:selected')
      .attr('class')
    if (type === 'category') {
      window.location.href = hUrl + 'case/category/' + slug + '/'
    } else if (type === 'tag') {
      window.location.href = hUrl + 'case/tag/' + slug + '/'
    }
    return false
  })
  if (typeof categorySlug !== 'undefined' && categorySlug) {
    $('#js-category-select').val(categorySlug)
  }

  $('.js-form').change(function() {
    // フォームの表示項目切り替え
    $('#js-contact-form-acc').toggleClass('active')
    $('#js-reservation-form-acc').toggleClass('active')
  })

  $('#js-user-hope').change(function() {
    // フォームの表示項目切り替え
    var val = $(this).val()
    switch (val) {
      case '①カウンセリングのみ（カウンセリングのみの場合はいつ頃施術をご希望か教えて下さい。）':
        $('#js-user-hope-acc').addClass('active')
        break
      default:
        $('#js-user-hope-acc').removeClass('active')
    }
  })

  // iPhoneでselect要素が長すぎて省略されてしまうのを防ぐ
  $('select').append('<optgroup label="" class="pc-hide sp-hide"></optgroup>')
})
